import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { DiscountType, IntentType, UnknownIntent } from '@debbie/common/dist/intents';
import { Select, Button } from '..';
import DepositCreator from './creators/DepositCreator';
import UnknownCreator from './creators/UnknownCreator';
const validateIntent = (intent) => {
    if (intent == null) {
        return false;
    }
    if (intent.type === IntentType.Deposit) {
        if (intent.collectionPeriod < 1) {
            return false;
        }
        if (intent.discount != null) {
            if (intent.discount.type === DiscountType.Amount &&
                Number.isNaN(intent.discount.amount)) {
                return false;
            }
            if (intent.discount.type === DiscountType.Fraction &&
                (Number.isNaN(intent.discount.fraction) ||
                    intent.discount.fraction > 1 ||
                    intent.discount.fraction < 0)) {
                return false;
            }
        }
    }
    return true;
};
const IntentCreator = (props) => {
    const [type, setType] = useState(IntentType.Unknown);
    const [intent, setIntent] = useState(null);
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Select, { value: type, onChange: (e) => {
                setType(e.target.value);
            } },
            React.createElement("option", { value: IntentType.Unknown }, lang.intentTypes[IntentType.Unknown]),
            React.createElement("option", { value: IntentType.Deposit }, lang.intentTypes[IntentType.Deposit])),
        type &&
            (() => {
                switch (type) {
                    case IntentType.Unknown:
                        return (React.createElement(UnknownCreator, { onEdit: (intent) => {
                                setIntent(intent);
                            } }));
                    case IntentType.Deposit:
                        return (React.createElement(DepositCreator, { onEdit: (intent) => {
                                setIntent(intent);
                            } }));
                    default:
                        return React.createElement("div", null, "Not supported");
                }
            })(),
        React.createElement(Button, { disabled: !validateIntent(intent), onClick: () => {
                if (intent != null) {
                    props.onCreate(intent);
                }
                else {
                    props.onCreate(UnknownIntent());
                }
            } }, lang.misc.update)));
};
export default IntentCreator;
//# sourceMappingURL=IntentCreator.js.map